import { Color, RED, GREEN, BLUE, YELLOW, LIGHT_BLUE, WHITE, GRAY, LIGHT_WHITE, DARK_GREEN, BLACK, DARK_DARK_GREEN, DARK_GRAY, DARK_BLUE } from './color'

export class LineStyle {
  constructor(readonly c: Color, readonly lineWidth = 1) {}
}

export const RED_LINE = new LineStyle(RED, 2)
export const GREEN_LINE = new LineStyle(GREEN, 2)
export const DARK_GREEN_LINE = new LineStyle(DARK_GREEN, 2)
export const DARK_DARK_GREEN_LINE = new LineStyle(DARK_DARK_GREEN, 2)
export const THICK_GREEN_LINE = new LineStyle(GREEN, 4)
export const BLUE_LINE = new LineStyle(BLUE, 4)
export const LIGHT_WHITE_LINE = new LineStyle(LIGHT_WHITE, 2)
export const LIGHT_BLUE_LINE = new LineStyle(LIGHT_BLUE, 2)
export const YELLOW_LINE = new LineStyle(YELLOW, 3)
export const WHITE_LINE = new LineStyle(WHITE, 4)
export const GRAY_LINE = new LineStyle(GRAY, 2)
export const DARK_GRAY_LINE = new LineStyle(DARK_GRAY, 2)
export const DARK_BLUE_LINE = new LineStyle(DARK_BLUE, 2)
export const BLACK_LINE = new LineStyle(BLACK, 2)
